'use client';

import { useSegmentStandardTrack } from '../lib/useSegmentStandardTrack';

type ElementInteractedProps = {
  entityName: string;
  interactionType?: string;
  itemCopy?: string;
  itemPosition?: number;
  sectionName?: string;
  parentEventId?: string;
  eventId?: string;
  additionalAttributes?: Record<string, unknown>;
};

type StandardElementInteractedPayload = {
  deployable_name: string | undefined;
  deployable_version: string | undefined;
  pageview_id: string | undefined;
  page_name: string | undefined;
  page_url: string | undefined;
  event_id: string;
  parent_event_id: string | undefined;
  entity_name: string;
  interaction_type: string | undefined;
  item_copy: string | undefined;
  item_position: number | undefined;
  section_name: string | undefined;
  additional_attributes: Record<string, unknown>;
};

export const useElementInteracted = ({
  entityName,
  interactionType,
  itemCopy,
  itemPosition,
  sectionName,
  parentEventId,
  eventId,
  additionalAttributes,
}: ElementInteractedProps) => {
  const track = useSegmentStandardTrack('Element Interacted');

  return (
    overrideProps?: Partial<StandardElementInteractedPayload> | null,
    callback?: () => void,
  ) =>
    void track(
      {
        entity_name: entityName,
        interaction_type: interactionType,
        item_copy: itemCopy,
        item_position: itemPosition,
        section_name: sectionName,
        ...overrideProps,
      },
      { eventId, parentEventId, additionalAttributes },
    )?.finally(() => {
      callback?.();
    });
};
